var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 15,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8744 11.3749C19.8744 12.8242 18.6992 14 17.2493 14H3V3.62508C3 2.17523 4.17523 1 5.62508 1H19.8744V11.3749Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2305 8.71358H16.3157C16.3496 8.71358 16.4142 8.70829 16.4454 8.70141C16.6539 8.65643 16.8274 8.47123 16.8274 8.21936C16.8274 7.96749 16.6539 7.78176 16.4454 7.73678C16.4147 7.7299 16.3501 7.72461 16.3157 7.72461H15.2305V8.71358Z",
    fill: "url(#paint0_linear_262_38797)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1873 1.87329C15.1517 1.87329 14.3125 2.71251 14.3125 3.74805V5.69529H16.9656C17.027 5.69529 17.1021 5.69953 17.1492 5.70217C17.7498 5.73233 18.1922 6.04082 18.1922 6.57579C18.1922 6.99646 17.8895 7.35627 17.3387 7.43723V7.4584C17.9472 7.50073 18.4128 7.83568 18.4128 8.36323C18.4128 8.93418 17.9017 9.30088 17.2201 9.30088H14.3125V13.1229H17.0625C18.098 13.1229 18.9372 12.2831 18.9372 11.2481V1.87329H16.1873Z",
    fill: "url(#paint1_linear_262_38797)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6983 6.71105C16.6983 6.46341 16.5248 6.29726 16.321 6.26286C16.302 6.25969 16.2501 6.25439 16.2141 6.25439H15.2305V7.16717H16.2141C16.2501 7.16717 16.302 7.16188 16.321 7.1587C16.5248 7.12484 16.6983 6.95868 16.6983 6.71105Z",
    fill: "url(#paint2_linear_262_38797)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8123 1.87537C4.77676 1.87537 3.93754 2.71459 3.93754 3.75012V8.38013C4.46351 8.63465 5.00641 8.8008 5.55937 8.8008C6.20757 8.8008 6.56368 8.405 6.56368 7.87268V5.69737H8.17598V7.87268C8.17598 8.72354 7.65372 9.40614 5.86151 9.40614C4.78311 9.40614 3.93701 9.17331 3.93701 9.17331V13.1244H6.68697C7.72251 13.1244 8.56173 12.2847 8.56173 11.2497V1.87537H5.8123Z",
    fill: "url(#paint3_linear_262_38797)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9978 1.87537C9.96227 1.87537 9.12305 2.71459 9.12305 3.75012V6.20482C9.59822 5.79738 10.4194 5.54286 11.7545 5.60265C12.4688 5.6344 13.2266 5.82595 13.2266 5.82595V6.61967C12.8472 6.42759 12.3926 6.24927 11.8069 6.20535C10.7941 6.12862 10.1845 6.6239 10.1845 7.50016C10.1845 8.37642 10.7941 8.87117 11.8069 8.79445C12.3926 8.75053 12.8535 8.56744 13.2266 8.38065V9.17384C13.2266 9.17384 12.4688 9.36539 11.7545 9.39767C10.42 9.45746 9.59822 9.20294 9.12305 8.7955V13.125H11.873C12.9085 13.125 13.7478 12.2852 13.7478 11.2502V1.87537H10.9978Z",
    fill: "url(#paint4_linear_262_38797)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_262_38797",
    x1: 14.314,
    y1: 8.21937,
    x2: 18.9508,
    y2: 8.21937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#008D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#4FAC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_262_38797",
    x1: 14.3124,
    y1: 7.49784,
    x2: 18.9493,
    y2: 7.49784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#008D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#4FAC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_262_38797",
    x1: 14.3139,
    y1: 6.71116,
    x2: 18.9506,
    y2: 6.71116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#008D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#4FAC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_262_38797",
    x1: 3.93141,
    y1: 7.49992,
    x2: 8.6399,
    y2: 7.49992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#005999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#006FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_262_38797",
    x1: 9.09523,
    y1: 7.49992,
    x2: 13.6682,
    y2: 7.49992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#8C3039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE273F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DF1E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1846"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardJcb);
export default __webpack_public_path__ + "static/media/card_jcb.b4f73ff3711cf083f1f85eb71d663a80.svg";
export { ForwardRef as ReactComponent };